import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotFound from './Notfound';
export default function Protected({ children }) {
const navigate=useNavigate();
  // Retrieve session data from localStorage
  const storedFormData = sessionStorage.getItem('formData');
  const finalSession = storedFormData ? JSON.parse(storedFormData) : null;

  // If session data does not exist (user is not authenticated), redirect to login
  if (!finalSession || !finalSession.name) {
    console.log(finalSession)
   navigate('./home')
    return  <NotFound/>;
  }

  // If authenticated, render the children (protected content)
  return <>{children}</>;
}
